import { CertificateListView } from "@/api/williams/certificates";
import { Certifications, CertificationsTable } from "./components/Certifications";
import { ExpandableCard, SearchField, SelectedItemsProvider, useSelectedItems } from "../components";
import { Expirations } from "./components/Expirations";
import { getFullPath, routes } from "../routes";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { WelderListToolbar } from "./WelderListToolbar";
import { WelderListView } from "@/api/williams/welders";
import { Welders, WeldersTable } from "./components/Welders";

export type WelderListViewType = "list" | "certifications" | "expirations";

export function WelderList() {
  return (
    <SelectedItemsProvider>
      <WelderListContent />
    </SelectedItemsProvider>
  );
}

function WelderListContent() {
  const { view = "list" } = useParams<{ view: WelderListViewType }>();
  const [searchParams] = useSearchParams();
  const searchString = searchParams.get("search") ?? undefined;

  const selected = useSelectedItems<WelderListView | CertificateListView>();
  const navigate = useNavigate();

  function handleViewChanged(e: React.ChangeEvent<HTMLSelectElement>) {
    navigate(
      getFullPath(routes.welder.list(e.target.value), {
        search: searchString,
      })
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3>Welders</h3>
        <div className="d-md-none">
          <WelderListToolbar view={view} />
        </div>
      </div>
      <div className="d-flex flex-column-reverse flex-md-row justify-content-between mb-3">
        <SearchField />
        <div className="d-md-flex">
          <div className="d-none d-md-block px-2">
            <WelderListToolbar view={view} />
          </div>
          <div className="mb-2 mb-md-0">
            <select className="form-select" value={view} onChange={handleViewChanged}>
              <option value="list">Welders</option>
              <option value="certifications">Certifications</option>
              <option value="expirations">Expirations</option>
            </select>
          </div>
        </div>
      </div>

      {selected.items.length > 0 && (
        <div className="mb-2">
          <ExpandableCard caption={`Selected Items (${selected.items.length})`}>
            {view === "list" && <WeldersTable data={selected.items as WelderListView[]} search={searchString} />}
            {view === "certifications" && (
              <CertificationsTable data={selected.items as CertificateListView[]} search={searchString} />
            )}
          </ExpandableCard>
        </div>
      )}

      {view === "list" && <Welders filters={{ searchString }} expanded={true} allowExpand={false} />}
      {view === "certifications" && <Certifications filters={{ searchString }} expanded={true} allowExpand={false} />}
      {view === "expirations" && <Expirations filters={{ searchString }} expanded={true} allowExpand={false} />}
    </>
  );
}
